import React from "react";

/** Shared left panel for auth split layout. */
const AuthLeftPanel = ({ variant = "login" }) => (
  <div className="auth-split-left">
    <div className="auth-left-glow" aria-hidden="true" />
    <div className="auth-orb auth-orb-1" aria-hidden="true" />
    <div className="auth-orb auth-orb-2" aria-hidden="true" />
    <div className="auth-orb auth-orb-3" aria-hidden="true" />

    <div className="auth-left-main">
      <h1 className="auth-hero">The Oracle HCM expert that never sleeps.</h1>
      <p className="auth-hero-sub">
        Instant answers. Release-aware. Specific to your implementation.
      </p>

      {variant === "login" ? (
        <div className="auth-chat-preview" aria-hidden="true">
          <div className="preview-header">
            <div className="preview-dot red" />
            <div className="preview-dot yellow" />
            <div className="preview-dot green" />
            <span className="preview-title">Edge AI</span>
          </div>
          <div className="preview-messages">
            <div className="preview-user-msg">
              How do I configure absence plans in Oracle HCM?
            </div>
            <div className="preview-bot-msg">
              <div className="preview-bot-icon">⬡</div>
              <div className="preview-bot-text">
                Navigate to <strong>Setup and Maintenance → Absence Management → Absence Plans</strong>.
                Click Create and define your plan type, accrual rules, and eligibility criteria…
                <span className="preview-cursor">|</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="auth-register-benefits">
          <p className="auth-benefits-label">What you get with Edge AI</p>
          <div className="auth-benefit">
            <div className="auth-benefit-icon">✓</div>
            <div>
              <h4>Instant Oracle HCM answers</h4>
              <p>
                Get precise answers to implementation and configuration questions in seconds.
              </p>
            </div>
          </div>
          <div className="auth-benefit">
            <div className="auth-benefit-icon">✓</div>
            <div>
              <h4>Release-aware responses</h4>
              <p>
                Always up to date with Oracle HCM 25C and 25D release notes and changes.
              </p>
            </div>
          </div>
          <div className="auth-benefit">
            <div className="auth-benefit-icon">✓</div>
            <div>
              <h4>Your company&apos;s docs, privately indexed</h4>
              <p>
                Upload your Oracle implementation guides and get answers specific to your exact setup.
              </p>
            </div>
          </div>
          <div className="auth-benefit">
            <div className="auth-benefit-icon">✓</div>
            <div>
              <h4>Canadian data residency</h4>
              <p>All data stored on Canadian servers. Your data never leaves Canada.</p>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
);

export default AuthLeftPanel;
